module.exports = __webpack_public_path__ + "static/assets/877ce009dd034612a6a8ae7088c6d95a.svg";